enum DoorTypesEnum {
  GARAGE_GROUND_LEVEL = 'GARAGE_GROUND_LEVEL',
  LOADING_DOCK = 'LOADING_DOCK',
}

export default DoorTypesEnum;
